export const SITE_ORIGIN = "https://juegoxima.com";
export const PRIVATE_LEARN_BASE = "/game/learn";
export const PUBLIC_LEARN_BASE = "/aprender";
export const LEARN_HERO_IMAGE = "/learn/assets/generated/xima-learn-hero-20260615.png";
export const LEARN_OG_IMAGE = `${SITE_ORIGIN}${LEARN_HERO_IMAGE}`;

const cleanSlug = (slug) =>
  String(slug || "")
    .trim()
    .replace(/^\/+|\/+$/g, "")
    .toLowerCase();

export const privateLearnRoute = (slug = "") => {
  const nextSlug = cleanSlug(slug);
  return nextSlug ? `${PRIVATE_LEARN_BASE}/${nextSlug}` : PRIVATE_LEARN_BASE;
};

export const publicLearnRoute = (slug = "") => {
  const nextSlug = cleanSlug(slug);
  return nextSlug ? `${PUBLIC_LEARN_BASE}/${nextSlug}` : PUBLIC_LEARN_BASE;
};

export const canonicalLearnUrl = (slug = "") => `${SITE_ORIGIN}${publicLearnRoute(slug)}`;

export const isPublicLearnPathname = (pathname = "") => {
  const value = String(pathname || "").toLowerCase();
  return value === PUBLIC_LEARN_BASE || value.startsWith(`${PUBLIC_LEARN_BASE}/`);
};

export const normalizeLearnContentPath = (rawPath = "") => {
  const normalized = cleanSlug(rawPath);
  return normalized.startsWith("biblioteca/") ? normalized.slice("biblioteca/".length) : normalized;
};

export const resolveLegacyLearnHashRedirect = (hash = "") => {
  const value = String(hash || "");
  const match = value.match(/^#\/game\/learn(?:\/([^?#]+))?(\?[^#]*)?/i);
  if (!match) return "";

  const slug = String(match[1] || "").replace(/^\/+|\/+$/g, "").toLowerCase();
  const query = match[2] || "";
  return `${PUBLIC_LEARN_BASE}${slug ? `/${slug}` : ""}${query}`;
};

export const resolveLearnPathForMode = (path, isPublicMode) => {
  const value = String(path || "").trim();
  if (!value || /^https?:\/\//i.test(value)) return value;

  if (isPublicMode) {
    if (value === PRIVATE_LEARN_BASE) return PUBLIC_LEARN_BASE;
    if (value.startsWith(`${PRIVATE_LEARN_BASE}/`)) {
      return `${PUBLIC_LEARN_BASE}${value.slice(PRIVATE_LEARN_BASE.length)}`;
    }
    if (value === "/game" || value.startsWith("/game/")) return `/#${value}`;
  }

  if (!isPublicMode) {
    if (value === PUBLIC_LEARN_BASE) return PRIVATE_LEARN_BASE;
    if (value.startsWith(`${PUBLIC_LEARN_BASE}/`)) {
      return `${PRIVATE_LEARN_BASE}${value.slice(PUBLIC_LEARN_BASE.length)}`;
    }
  }

  return value;
};
